import { ADMIN, COMPANY, EDIT, FIRM } from 'common/constants/user';
import { useStore } from 'common/store';
import type { UseStoreValues } from 'common/types/store';

const EDIT_OR_BETTER = [ADMIN, EDIT];

// Permission rows can be narrowed to one feature; only cap-table rows and unnarrowed
// rows reach the cap table, which is the filter the server applies.
const CAP_TABLE_FEATURE = 'ct';

/**
 * Whether this user may run the cap table clear actions, matching what the server
 * enforces: a superuser always may, Scalar staff may when they also hold edit rights
 * on the company (directly, or across the firm). Anything unresolved counts as no.
 */
const useCanClearCapTable = (companyId?: number | null): boolean => {
  const [{ user, firmId, firmList }] = useStore() as UseStoreValues;

  if (user?.is_superuser) {
    return true;
  }
  if (!user?.is_staff || !companyId || !firmId) {
    return false;
  }

  const permissions = firmList?.find(firm => Number(firm.id) === Number(firmId))?.user_permissions ?? [];

  return permissions.some(
    ({ access_type: accessType, feature_object: featureObject }) =>
      EDIT_OR_BETTER.includes(accessType) &&
      (!featureObject?.feature || featureObject.feature === CAP_TABLE_FEATURE) &&
      ((featureObject?.object_type === COMPANY && Number(featureObject.object_id) === Number(companyId)) ||
        (featureObject?.object_type === FIRM && Number(featureObject.object_id) === Number(firmId)))
  );
};

export default useCanClearCapTable;
